<template>
  <main>
    <Button
      label="Ajouter help"
      icon="pi pi-plus"
      @click="visible = true"
      class="mt-2 p-button-secondary"
    />

    <Dialog
    :visible.sync="visible"
      modal
      header="Nouvelle help"
      :style="{ width: '50vw' }"
    >
      <Card>
        <!-- <template #title> Nouvelle help </template> -->
        <template #content>
          <div class="mb-4">
            <span class="p-float-label">
              <InputNumber id="number" v-model="help.number" />
              <label for="number">N° emplacement</label>
            </span>
          </div>
          <div class="p-inputgroup flex-1">
            <span class="p-float-label">
              <InputText id="name" type="text" v-model="help.name" />
              <label for="name">Nom</label>
            </span>
            <!-- <span class="p-float-label">
              <InputText id="label" type="text" v-model="help.label" />
              <label for="label">Label</label>
            </span> -->
          </div>
        </template>
      </Card>
      <template #footer>
        <Button
          label="Annuler"
          icon="pi pi-times"
          @click="visible = false"
          text
        />
        <Button
          label="Valider"
          icon="pi pi-check"
          @click="saveHelp"
          autofocus
        />
      </template>
    </Dialog>
  </main>
</template>
<script>

export default {
  data() {
    return {
      emit: ["visible"],

      visible: false,
      help: {},
    };
  },

  methods: {
    async saveHelp() {
      // const res = await ApiService.saveHelp({
      //   ...this.help,
      //   list: [{ id: 1, name: "" }],
      // });
      try {
      const res = await fetch(process.env.VUE_APP_API_BASE_URL + '/api/v1/helps/saveHelp', {
        method: 'POST',
        body: JSON.stringify(this.help),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.localStorage.token}`,

        }
      })
      console.log(res);

    } catch (error) {
      console.log(error)
    }
      this.visible = false;
      this.$emit("visible", false);
    },
  },
};
</script>

<style></style>
